import { createContext } from 'react';
//////////////////////////////////////////////////

const VirtualizedListContext = createContext();

VirtualizedListContext.displayName = 'VirtualizedListContext';

export default VirtualizedListContext;
